import React from "react";
import styled from "styled-components";

import { AlertWarningIcon } from "@adsk/alloy-react-icon";
import { useLocale } from "@adsk/alloy-react-locale";
import theme from "@adsk/alloy-react-theme";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledAlertWarningIcon = styled(AlertWarningIcon)`
  color: ${theme.colors.charcoal700};
`;

const Message = styled.div`
  ${theme.typography.bodySmall}
  color: ${theme.colors.charcoal700};
  margin-left: 9px;
`;

interface AssetsMissingEntitiesProps {
  count: number;
  loading?: boolean;
  error?: boolean;
  data?: unknown;
  relationshipCount?: number;
}

function AssetsMissingEntities({
  count,
}: AssetsMissingEntitiesProps): React.ReactNode {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  return (
    <Container>
      <Content>
        <StyledAlertWarningIcon />
        <Message>
          {T.translate("COULDNT_DISPLAY_ASSET_REFERENCES", { context: count })}
        </Message>
      </Content>
    </Container>
  );
}

export default AssetsMissingEntities;
